// Brand artwork for the merchant dashboard chrome (CB-12, INF-1). Lives in theme/ with
// the rest of the white-label bundle: a different tenant swaps these PNGs (and
// tokens.ts `brand`), nothing else in the surface changes. Copied from the merchant
// design export (claude-design-raw-html/merchant-dashboard/uploads/bookingdei-ticket-
// lockup-en*.png — the same files the customer and admin surfaces ship): a light and a
// reversed (dark-theme) variant; theme.css `--rail-logo` / `--rail-logo-rev` decide
// which one shows. The designer credit mark is deliberately not shipped.
import lockup from './assets/brand-lockup.png';
import lockupReversed from './assets/brand-lockup-rev.png';

export const brandAssets = {
  /** Full lockup for light surfaces (rail + mobile top bar in the light theme). */
  lockup,
  /** Reversed lockup for dark surfaces (the dark theme). */
  lockupReversed,
} as const;
